<script lang="ts">
  // Loading placeholder with the shimmer. Use it instead of inline
  // `<span class="skeleton" style=…>`.
  //   <Skeleton />                                  rect, full width, 14px
  //   <Skeleton width="40%" height="18px" />        rect
  //   <Skeleton variant="text" width="60%" />       one line of text (1em high)
  //   <Skeleton variant="lines" lines={3} />        a paragraph (last line shorter)
  //   <Skeleton variant="circle" size="32px" />     avatar / icon
  interface Props {
    variant?: 'rect' | 'text' | 'circle' | 'lines';
    width?: string;
    height?: string;
    /** Diameter for circle. */
    size?: string;
    lines?: number;
    radius?: string;
    class?: string;
  }
  let { variant = 'rect', width = '100%', height = '14px', size = '32px', lines = 3, radius, class: cls = '' }: Props = $props();
</script>

{#if variant === 'lines'}
  <span class="lines {cls}" style:width aria-hidden="true">
    {#each Array.from({ length: Math.max(1, lines) }, (_, i) => i) as i (i)}
      <span class="skeleton text" style:width={i === lines - 1 && lines > 1 ? '60%' : '100%'}></span>
    {/each}
  </span>
{:else if variant === 'circle'}
  <span class="skeleton circle {cls}" style:width={size} style:height={size} aria-hidden="true"></span>
{:else if variant === 'text'}
  <span class="skeleton text {cls}" style:width style:border-radius={radius} aria-hidden="true"></span>
{:else}
  <span class="skeleton rect {cls}" style:width style:height style:border-radius={radius} aria-hidden="true"></span>
{/if}

<style>
  .skeleton { display: block; flex-shrink: 0; }
  .text { height: 0.8em; margin: 0.25em 0; border-radius: var(--radius-2xs); }
  .circle { border-radius: var(--radius-full); }
  .lines { display: flex; flex-direction: column; gap: var(--space-1); }
</style>
